import React, { useMemo, useState, useCallback, useEffect } from 'react';
import { getValue, setValue } from '../../utils/LocalStorageUtils';
import MultipurposeButtonView from '../view/MultipurposeButtonView';

/**
 *
 * @param {String} id - uid, used as key to stor datai n local storage
 * @param {Function} onClick - what happnes when you click on the main button
 * @param {Array} options - array of object representing buttons in the following format:
 *  {
 *      id: button uid,
 *      label: button text <optional (but why would you leave it out)>
 *      varaint: mui button variants <optional> - if left empty will use "contained"
 *      color: hex value <optional> - if left empty will use OT primary color
 *      onClick: self explanatory
 *      customCSS: customCSS for the main button
 *      muiBtnProps: object of MUI button props
 *  }
 *
 *
 */
const MultipurposeButtonEngine = ({ id, options = [] }) => {
  const indexedButtons = useMemo(() => {
    const iBtns = {};
    options.forEach(o => (iBtns[o.id] = o));
    return iBtns;
  }, [options]);

  const [activeButton, setActiveButton] = useState(
    (getValue(id) && indexedButtons[getValue(id)]) || options[0]
  );
  const [isMainButtonInactive, setIsMainButtonInactive] = useState(false);
  const [menuAnchor, setMenuAnchor] = useState(null);

  const onButtonChange = useCallback(
    bId => {
      setValue(id, bId);
      setActiveButton(indexedButtons[bId]);
      setMenuAnchor(null);
    },
    [indexedButtons, id, options]
  );

  const onClick = useCallback(
    e => {
      const func = indexedButtons[activeButton.id].onClick;

      if (func) {
        func(e);
      }
    },
    [indexedButtons, activeButton, options]
  );

  const viewProps = {
    isMainButtonInactive,
    setIsMainButtonInactive,
    menuAnchor,
    setMenuAnchor,
    options,
    onButtonChange,
    ...activeButton,
    onClick
  };

  return <MultipurposeButtonView {...viewProps} />;
};

export default MultipurposeButtonEngine;
